import React, { useEffect } from 'react'
import Header from '../components/Header'
import Leftmenu from '../components/Leftmenu'
import Rightmenu from '../components/Rightmenu'
import { useOutletContext } from "react-router-dom";
import createEvent from '../../images/create-event.jpg';
import EventCard from '../components/EventCard';
import validator from 'validator';
function Events() {
  const {user, token} = useOutletContext();
  const [page, setPage] = React.useState('events');
  const [events, setEvents] = React.useState([]);
  const [Myevents, setMyevents] = React.useState([]);
  const [eventform, setEventform] = React.useState({
    event_name: '',
    event_description: '',
    event_date: '',
    event_time: '',
    event_venue: '',
    event_image: '',
  });
  const [errors, setErrors] = React.useState('');
  const HandleformChange = (event) => {
    setEventform({
      ...eventform,
      [event.target.name]: event.target.value,
    });
   
  }
const HandlefileChange = (event) => {
  if (!event.target.files[0]) {
    return;
  }

  const file = event.target.files[0];
  const fileType = file.type;
  const validImageTypes = ['image/jpeg', 'image/png', 'image/jpg'];

  if (!validImageTypes.includes(fileType)) {
    alert('Please upload an image file');
    event.target.value = ""; // reset input
    return;
  }

  setEventform({
    ...eventform,
    [event.target.name]: file,
  });

  
};

  const HandlecreateEvent = (e) => {
    e.preventDefault();
  const formData = new FormData();
  formData.append('event_name', eventform.event_name);
  formData.append('event_description', eventform.event_description);
  formData.append('event_date', eventform.event_date);
  formData.append('event_time', eventform.event_time);
  formData.append('event_venue', eventform.event_venue);
  formData.append('event_image', eventform.event_image);
 

      fetch('/api/create-event', {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + token,
      },
      body: formData
      ,
    })
      .then((response) => response.json())
      .then((data) => {
       if(data.errors){
        setErrors(data.errors)
       }
        else if(data.message){
          setPage('events');
        }
      })
      .catch((error) => {
       
      });
  }
  const getEventlist = () => {
    fetch('/api/get-events', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    }).then((response) => response.json())
      .then((data) => {
        console.log(data);
        setEvents(data.data);
      }).catch((error) => {
       
      });
  }
  const getMyEventlist = () => {
    fetch('/api/get-my-events', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    }).then((response) => response.json())
      .then((data) => {
        console.log(data);
        setMyevents(data.data);
      }).catch((error) => {
       
      });
  }
  useEffect(() => {
    getEventlist();
    getMyEventlist();
  },[page])
  return (
    <div>
      <Header />
      <Leftmenu />
      <Rightmenu />
  <div className="main-content right-chat-active">
  <div className="middle-sidebar-bottom">
  <div className="middle-sidebar-left">
    <div className="row">
      {page == "events" && 
      <div className="col-xl-12">
        <div class="card shadow-xss w-100 d-block d-flex border-0 p-4 mb-3"><div class="card-body d-flex align-items-center p-0"><h2 class="fw-700 mb-0 mt-0 font-md text-grey-900">Events</h2></div></div>
        <div className="row">
          {(user?.role == "admin" || user?.role == "faculty") &&  <div className="col-lg-4 col-md-6 pe-2 ps-2">
            <div className="card p-3 bg-white w-100 hover-card border-0 shadow-xss rounded-xxl border-0 mb-3 overflow-hidden ">
              <div className="card-image w-100">
                <img src={createEvent} alt="event" className="w-100 rounded-3" />
              </div>
              <div className="card-body d-flex ps-0 pe-0 pb-0">
               
                <h2 className="fw-700 lh-3 font-xss">Create Your Own Event
              
                </h2>
              </div>
              <div className="card-body p-0">
               
                <button onClick={() =>setPage('create-event') } className="w-100 btn bg-current text-white ">Create Now</button>
                <button onClick={() =>setPage('my-event') } className="w-100 btn bg-current text-white my-2">My Events</button>
              </div>
            </div>
          </div>}
          {events.length > 0 && events.map((event, index) => (
            
            <EventCard data={event} type={"event"} />
          ))
          }
        </div>
      </div> }        
      {page == "create-event" && <div className="col-xl-12">
          <div className="middle-wrap">
              <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                    <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                                     
                      <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">
                        Create Event
                      </h4>
                    </div>
                    <div className="card-body p-lg-5 p-4 w-100 border-0">
                                        <form onSubmit={HandlecreateEvent}>
                                            <div className="row">
                                                <h3 className="fw-600 font-xss mb-3">
                                                   Event Information
                                                </h3>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                          Name of the Event 
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="event_name"
                                                            className="form-control"
                                                            onChange={HandleformChange}
                                                        />
                                                        {errors.event_name && <span className="text-danger">{errors.event_name}</span>}
                                                      
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                          Event Date 
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <input
                                                            type="date"
                                                            name="event_date"
                                                            className="form-control"
                                                            onChange={HandleformChange}
                                                        />
                                                        {errors.event_date && <span className="text-danger">{errors.event_date}</span>}
                                                    </div>
                                                </div>
                                                <div className='col-lg-12 mb-3'>
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                          Event Time
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <input
                                                            type="time"
                                                            name="event_time"
                                                            className="form-control"
                                                            onChange={HandleformChange}
                                                        />
                                                      {errors.event_time && <span className="text-danger">{errors.event_time}</span>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                          Event Venue 
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="event_venue"
                                                            className="form-control"
                                                            onChange={HandleformChange}
                                                        />
                                                        {errors.event_venue && <span className="text-danger">{errors.event_venue}</span>}
                                                      
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                          Event Description 
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                       <textarea className="form-control" name='event_description' onChange={HandleformChange} id="exampleFormControlTextarea1" rows={3} defaultValue={""} />
                                                      {errors.event_description && <span className="text-danger">{errors.event_description}</span>}
                                                      
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                          Event Image (740px*493px)
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <input
                                                            type="file"
                                                            name="event_image"
                                                            className="form-control"
                                                             onChange={HandlefileChange}
                                                        />
                                                        {errors.event_image && <span className="text-danger">{errors.event_image}</span>}
                                                    </div>
                                                </div>

                                              
                                            </div>
                                            <div className="col-lg-12 mb-0 mt-2">
                                                <button
                                                    type="submit"
                                                    className="btn bg-current text-center text-white font-xsss fw-600 p-3 w-175 rounded-3 d-inline-block"
                                                >
                                                   Create Event
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
       
       </div>}    
       {(page =="my-event" ) &&  <div className="col-xl-12">
        
        <div className="row">
         {(user?.role == "admin" || user?.role == "faculty") && 
         <div className="col-lg-12">
         <div class="card shadow-xss w-100 d-block d-flex border-0 p-4 mb-3"><div class="card-body d-flex align-items-center p-0"><h2 class="fw-700 mb-0 mt-0 font-md text-grey-900">My Events</h2></div></div>
         <div className="row">
         {events.map((event, index) => (
            
            <EventCard data={event} type={"my-event"} />
          ))
          }
         </div>
         </div>
         }
        </div>
      </div>} 
    </div>
  </div>
</div>
</div>

    </div>
  )
}

export default Events